import React, { useState, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './ContentStyle.css';
import ApiSender from '../common/ApiLogic';

function SuccessPage() {

  const location = useLocation();
  const [userId, setUserId] = useState(null);
  const [token, setToken] = useState(null);
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }

  useEffect(() => {
    async function begin() {
      const apiSender = new ApiSender();
      
      apiSender.sendLogs("success", params);

      const playGameResult = await apiSender.playGame(paramsObject.epgw_payment_payload);
      if (playGameResult.success) {
        const code = playGameResult.code;
        if(code !== null && code != undefined && code === 2000)
        {
          setUserId(playGameResult.userId);
          setToken(playGameResult.token);
        }
      }
    }
    begin();
  }, []);


  const redirectToGamePortal = () => {
    window.location.href = process.env.REACT_APP_GAME_PORTAL + (userId ? `?userId=${userId}` : "") + (token ? `&token=${token}` : "");
  };

  return (
    <div className="Aa000">
      <div className='container'>
        <div className='header'>
          <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-logo.png' /></div>
        </div>
        <div className='form-content'>
          <div className='form-content-top'>
            <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-banner.png' /></div>
          </div>
          <div className='title'>
            <h4>Congratulations! You have subscribed successfully</h4>
          </div>
          <div className='button'>
            <button onClick={redirectToGamePortal}>Start Playing</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuccessPage;